import { Editorial } from '@anews/types'

import { RootState } from '../reducers'

import { createMapSelector } from './helpers'

const getEditorials = (state: RootState) => state.editorials.list.data

export const editorialsMap = createMapSelector<Editorial, string>(getEditorials, 'id', 'name')
